var CustomerRequestModule = (function () {
    function CustomerRequestModule() {
    }
    return CustomerRequestModule;
}());
export { CustomerRequestModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer-request/customer-request.module.ts.pre-build-optimizer.js